import React, {Component} from 'react';
import {connect} from 'react-redux';
import fscreen from 'fscreen';
import {Actions} from '../../../common/actions';
import {Icon, Table} from 'semantic-ui-react';
import {paths} from '../../../common/dictionaries/urls';
import TimerCurrentDate from '../../../common/components/timerCurrentDate';
import {getDifferenceBetweenDates} from '../../../common/util/date';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {getSystemParameterValue} from '../../../common/util/parametersUtils';
import moment from 'moment';
import './list.scss';

let timer = null;
const dateFormat = 'DD-MMM-YYYY';
const dateFormatWithHour = 'DD-MMM-YYYY hh:mm:ss';

class LiquidationsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'isFullScreen': false,
      'importationsRefreshTime': getSystemParameterValue(props.systemParameters,
        'INTERVAL_CHANGE_IMPORTATIONS_SLIDE') || 60,
    };
  }

  componentDidMount() {
    this.props.emptyLiquidationsList();
    this.changeFullScreen();
    this.startTimer();
  }

  changeFullScreen() {
    if (fscreen.fullscreenEnabled) {
      fscreen.addEventListener('fullscreenchange', this.handler.bind(this), false);
    }
  }

  handler() {
    if (!fscreen.fullscreenElement) {
      this.setState({'isFullScreen': false});
    }
  }

  componentDidUpdate(prevProps) {
    const {type, systemParameters} = this.props;
    const {importationsRefreshTime} = this.state;
    if (prevProps.type !== type) {
      this.props.emptyLiquidationsList();
      this.stopTimer();
      this.startTimer();
    }

    if (prevProps.systemParameters !== systemParameters) {
      const interval = getSystemParameterValue(systemParameters, 'INTERVAL_REFRESH_IMPORTATIONS');
      if (interval && interval !== importationsRefreshTime) {
        this.stopTimer();
        this.setState({'importationsRefreshTime': interval}, () => this.startTimer());
      }
    }
  }

  startTimer() {
    const {type} = this.props;
    const {importationsRefreshTime} = this.state;

    this.props.fetchLiquidationsList(type);

    timer = setInterval(() => {
      this.props.fetchLiquidationsList(type);
    }, importationsRefreshTime * 1000);
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  stopTimer() {
    if (timer) {
      clearInterval(timer);
    }
  }

  goToHome() {
    this.props.push(paths.Home);
  }

  toggleFullScreen() {
    if (!fscreen.fullscreenElement) {
      fscreen.requestFullscreen(document.documentElement);
      this.setState({'isFullScreen': true});
    } else {
      fscreen.exitFullscreen();
      this.setState({'isFullScreen': false});
    }
  }

  render() {
    const icon = this.state.isFullScreen ? 'compress' : 'expand';
    const typeLiquidations = this.props.type === 'vehicles' ? 'Vehículos' : 'Repuestos';

    return (
      <div className='liquidations-page'>
        <div className='title-bar'>
          <div className='title'>
            <Icon link name={'home'} color='red' size='big'
              onClick={this.goToHome.bind(this)} />
            <Icon link name={icon} size='big'
              onClick={this.toggleFullScreen.bind(this)} />
            <h2>Importaciones de {typeLiquidations}</h2>
            <div className='title-bar-actions'>
              <TimerCurrentDate />
            </div>
          </div>
        </div>

        <Table striped className='scrollable-body'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>FACTURA</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>ORDEN</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>PEDIDO FACTURA</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>FECHA EMBARQUE</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>FECHA ARRIBO</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>NOMBRE IMPORTADOR</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>USUARIO</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>FECHA LIQUIDACION</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>LEADTIME</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>ESTADO</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
      
          <Table.Body>
            {this.renderImportations()}
          </Table.Body>
        </Table>
      </div>
    );
  }

  getLeadTime(boardingDate, settlementDate) {
    return getDifferenceBetweenDates(boardingDate, settlementDate);
  }

  renderImportations() {
    const {liquidations} = this.props;
    if (!liquidations.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={10}>No hay liquidaciones de importaciones</Table.Cell>
        </Table.Row>
      );
    }

    return liquidations.map((element, index) => {
      const classByStatus = this.getClassByStatus(element.importStatus.toUpperCase());
      const leadtime = this.getLeadTime(element.boardingDate, element.settlementDate);
      const boardingDateFormatted = moment(element.boardingDate).format(dateFormat);
      const arrivalDateFormatted = moment(element.arrivalDate).format(dateFormat);
      const settlementDateFormatted = moment(element.settlementDate).format(dateFormatWithHour);

      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.invoice}</Table.Cell>
          <Table.Cell textAlign='center'>{element.order}</Table.Cell>
          <Table.Cell textAlign='center' className={`invoice ${classByStatus}`}
            onClick={this.seeDetailClick.bind(this, element.invoiceOrder)}>
            {element.invoiceOrder}
          </Table.Cell>
          <Table.Cell textAlign='center'>{boardingDateFormatted}</Table.Cell>
          <Table.Cell textAlign='center'>{arrivalDateFormatted}</Table.Cell>
          <Table.Cell textAlign='center'>{element.importerName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.user.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{settlementDateFormatted}</Table.Cell>
          <Table.Cell textAlign='center'>
            {leadtime ? `${getNumericValue(leadtime, 0)} D` : ''}
          </Table.Cell>
          <Table.Cell textAlign='center' className={`status ${classByStatus}`}>{element.importStatus}</Table.Cell>
        </Table.Row>
      );
    });
  }

  seeDetailClick(invoiceOrder) {
    const {type} = this.props;
    if (type === 'parts') {
      return null;
    }
    this.props.navigateTo(`/liquidaciones/detalle/${invoiceOrder}`);
  }
  
  getClassByStatus(status) {
    switch (status) {
      default:
      case 'PEDIDO':
        return 'ordered';
      case 'EMBARCADO':
        return 'embarked';
      case 'PRELIQUIDADO':
        return 'preliquidated';
      case 'LIQUIDADO':
        return 'liquidated';
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.liquidationsList.loading,
    'liquidations': state.liquidationsList.list,
    'systemParameters': state.parameters.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchLiquidationsList,
  emptyLiquidationsList,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchLiquidationsList,
  emptyLiquidationsList,
  navigateTo,
})(LiquidationsList);
